import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import AuthService, { TAB_KEY } from "../../../services/authService";
import UserService from "../../../services/userService";
import { LStorage, useQuery } from "../../../services/utils";
import { updateAuthUser } from "../../../store/actions/auth";
import { IAppState } from "../../../store/reducers";
import { AuthState } from "../../../store/reducers/auth";
import MedicationsForm from "../../MedicationsForm";
import InsuranceInfo from "../../RegistrationComponents/InsuranceInfo";
import OuraInfo from "../../RegistrationComponents/OuraInfo";
import PaymentInfo from "../../RegistrationComponents/PaymentInfo";
import PersonalInfo from "../../RegistrationComponents/PersonalInfo";
import "./styles.scss";

export const FormReviewDetails = () => {
  const { authUser } = useSelector<IAppState, AuthState>((s) => s.auth);

  const getTab = () => LStorage.getItem(TAB_KEY, true).tab;
  const saveTab = (newTab: string) =>
    LStorage.setItem(TAB_KEY, { tab: newTab });

  const history = useHistory();
  const query = useQuery();
  const dispatch = useDispatch();

  const [step, setStep] = useState<string>(
    query.get("step") || getTab() || "info",
  );

  useEffect(() => {
    if (query.get("step")) {
      history.push("/profile"); // remove step=___ from query
    }

    if (authUser) {
      UserService.getSimpleUser(authUser.id)
        .then((user) => {
          AuthService.updateUserInfo(user.data);
          dispatch(updateAuthUser(user.data));
        })
        .catch((e) => console.log(e.message));
    }
  }, []);

  useEffect(() => {
    saveTab(step);
  }, [step]);

  const navItems = {
    info: "Personal",
    med: "Medication",
    insurance: "Insurance",
    payment: "Payment",
    oura: "Oura Sync",
  };

  const handleChange = (_: React.SyntheticEvent | any, newValue: string) => {
    setStep(newValue);
  };

  useEffect(() => {
    if (step && !Object.keys(navItems).includes(step)) {
      return history.push("patientDashboardPage");
    }
  }, [step]);

  const renderNavigation = () => {
    if (false) {
      return (
        <FormControl fullWidth>
          <Select
            value={step}
            onChange={(e) => handleChange(e, e.target.value)}
            sx={{
              backgroundColor: "background.paper",
              "& .MuiSelect-select": {
                py: 1.5,
                px: 2,
              },
            }}
          >
            {Object.entries(navItems).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                <Typography>{label}</Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    return (
      <Tabs
        value={step}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        sx={{
          mt: 1,
          bgcolor: "background.paper",
          borderRadius: "8px",
          "& .MuiTab-root": {
            "&.Mui-selected": {
              color: "primary.main",
              fontWeight: 700,
            },
          },
          "& .MuiTabs-indicator": {
            backgroundColor: "primary.main",
            height: 3,
          },
        }}
      >
        {Object.entries(navItems).map(([key, label]) => (
          <Tab
            sx={{ borderRadius: "8px" }}
            key={key}
            label={label}
            value={key}
          />
        ))}
      </Tabs>
    );
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: { xs: '90%', md: 'fit-content' },
        }}
      >
        {renderNavigation()}
      </Box>

      <Box sx={{ width: "100%", maxWidth: { xs: "100%", md: "60%" } }}>
        {step === "info" && <PersonalInfo onContinue={() => {}} profile />}
        {step === "med" && <MedicationsForm />}
        {step === "insurance" && <InsuranceInfo onContinue={() => {}} />}
        {step === "payment" && <PaymentInfo onContinue={() => {}} profile />}
        {step === "oura" && <OuraInfo />}
      </Box>
    </Box>
  );
};

export default FormReviewDetails;
